import { render } from "./MainGiaoThongVaDichVuCong.vue?vue&type=template&id=43c33973"
import script from "./MainGiaoThongVaDichVuCong.vue?vue&type=script&lang=js"
export * from "./MainGiaoThongVaDichVuCong.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__